import React from 'react';
import './loader.css';
import logo from '../../common/logo.svg'

const Loader = () => {
    return (
        <div className={"loader-container container"}>
            <div className={"loader-container__content"}>
                <div className="lds-dual-ring"></div>
                <div className={"loader-container__logo"} style={{mask:`url(${logo})`,WebkitMask:`url(${logo})`}}></div>
            </div>
        </div>
    );
};
export default Loader;